// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"331a467c","399":"91cff0b9","498":"361516c7","628":"ed66212e","787":"08b1face","993":"c2133a72"}[chunkId] + ".chunk.js";
};